/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-07-24 15:01:01
 * @LastEditors: wl
 * @LastEditTime: 2020-07-24 16:08:18
 */ 
import axios from '../axios'



// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/util_data_upgrade',
        method: 'post',
        timeout: 20 * 60 * 1000,
        data
    })
}

//系统收费
export const sys_community_toll = (data) => {
    return axios({
        url: '/admin/service/sys_community_toll',
        method: 'post',
        timeout: 20 * 60 * 1000,
        data
    })
}

 
//收费标记
export const sys_community_toll_change = (data) => {
    return axios({
        url: '/admin/service/sys_community_toll_change',
        method: 'post',
        data
    })
}



//承建商接口
export const sys_community_toll_contractors = (data) => {
    return axios({
        url: '/admin/service/sys_community_toll_contractors',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/system.js